import { type FC, useState } from "react";
import { type ScoutsSavePrevSearchCondition } from "@clientFrontend/features/scout/types/scoutsSavePrevSearchCondition";
import { Presentation } from "./Presentation";

type Props = {
  prevSearchCondition: string;
  form: ScoutsSavePrevSearchCondition;
};

export const ScoutsSavePrevSearchConditionModal: FC<Props> = ({ prevSearchCondition, form }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <Presentation
      prevSearchCondition={prevSearchCondition}
      form={form}
      isModalOpen={isModalOpen}
      onOpenModal={handleOpenModal}
      onCloseModal={handleCloseModal}
    />
  );
};
